export const SidebarSkeleton = () => (
  <div className="flex w-full flex-1 flex-col gap-4 rounded border border-black/10 p-4 animate-pulse">
    <div className="flex gap-2">
      {Array.from({ length: 2 }).map((_, idx) => (
        <div key={idx} className="h-8 w-20 rounded bg-neutral-200" />
      ))}
    </div>
    <div className="flex-1 space-y-4 overflow-hidden">
      {Array.from({ length: 5 }).map((_, idx) => (
        <div key={idx} className=" flex flex-row space-x-2">
          <div className="h-[80px] w-1/5 rounded bg-neutral-200" />
          <div className="flex flex-col gap-2 w-4/5">
            <div className="h-4 w-1/3 rounded bg-neutral-200" />
            <div className="flex flex-col gap-1">
              <div className="h-4 w-full rounded bg-neutral-200" />
              <div className="h-4 w-full rounded bg-neutral-200" />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
)
